import mixpanel from 'mixpanel-browser';
import { getAuth } from 'services/auth.service';
import { socketEmit } from '@/services/socket';

try {
    const init = () => {
        mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || '', {
            persistence: 'localStorage',
            debug: process.env.NEXT_PUBLIC_ENVIRONMENT === 'devlopment',
            api_host: process.env.NEXT_PUBLIC_API_URL || 'http://localhost:7801'
        });
    };
    init();
} catch (error) {
    console.error(error);
}

export const identifyUser = (id) => {
    try {
        mixpanel.identify(id);
    } catch (e) { console.error(e); }
};

export const setMixpanelUser = ({
    Name, Email, Role, CompanyName
}) => {
    try {
        mixpanel.people.set({
            name: Name, Email, Role, CompanyName
        });
    } catch (e) { console.error(e); }
};
function safeWindowProp(getter, fallback = null) {
    try {
        if (typeof window !== 'undefined') {
            return getter();
        }
    } catch (e) {
        console.warn('Failed to read window property', e);
    }
    return fallback;
}
function collectEnvProps() {
    try {
        if (typeof window === 'undefined') return {};

        const ua = navigator.userAgent;
        let browser = 'Unknown';
        let browserVersion = '';
        let os = 'Unknown';

        // Simple browser detection
        if (/chrome/i.test(ua)) {
            browser = 'Chrome';
            browserVersion = ua.match(/Chrome\/([\d.]+)/)?.[1] || '';
        } else if (/firefox/i.test(ua)) {
            browser = 'Firefox';
            browserVersion = ua.match(/Firefox\/([\d.]+)/)?.[1] || '';
        } else if (/safari/i.test(ua) && !/chrome/i.test(ua)) {
            browser = 'Safari';
            browserVersion = ua.match(/Version\/([\d.]+)/)?.[1] || '';
        } else if (/edg/i.test(ua)) {
            browser = 'Edge';
            browserVersion = ua.match(/Edg\/([\d.]+)/)?.[1] || '';
        }

        // Simple OS detection
        if (/windows/i.test(ua)) os = 'Windows';
        else if (/mac/i.test(ua)) os = 'MacOS';
        else if (/linux/i.test(ua)) os = 'Linux';
        else if (/android/i.test(ua)) os = 'Android';
        else if (/iphone|ipad/i.test(ua)) os = 'iOS';

        return {
            browser,
            browser_version: browserVersion,
            os,
            screen_height: window.screen?.height,
            screen_width: window.screen?.width
        };
    } catch (e) {
        return {};
    }
}

export const trackEvent = (eventName = '', dataObj = {}) => {
    try {
        const data = {
            ...dataObj, 'email Id': getAuth()?.email, name: getAuth()?.name, event_type: 'browser'
        };
        let mixpanelData = {};
        try {
            const envData = collectEnvProps();
            mixpanelData = {
                device_id: mixpanel.get_property('$device_id'),
                current_url: safeWindowProp(() => window.location.href, ''),
                referrer: safeWindowProp(() => document.referrer, ''),
                ...envData
            };
        } catch (e) { console.log(e); }
        socketEmit('/mixpanel/custom', { event: `${eventName} Server`, properties: { ...data, ...mixpanelData } });
        mixpanel.track(eventName, data);
    } catch (e) { console.error(e); }
};

export const resetUser = () => {
    try {
        mixpanel.reset();
    } catch (e) { console.error(e); }
};
